import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Banner from '../sec_banner/component';
import { Row, Col } from '../util_grid/grid.js';
import { t } from '@utils/i18n';

import './styles/styles.scss';

class CategoryCollectionList extends PureComponent {
  render() {
    const { categories = [], store } = this.props;
    return (
      <Row className="category-collection-list">
        {categories.map((category, index) => {
          const { subTitle, name, url, products } = category || {};
          return (
            <Col xs={6} sm={4} md={3} key={index} className="collection-list-item">
              <Banner
                store={store}
                subtitle={subTitle || t('top10.collection.subtitle')}
                buttonText={t('top10.collection.buttonText')}
                title={name}
                url={url}
                products={products}
                variant="collection"
              />
            </Col>
          );
        })}
      </Row>
    );
  }
}


CategoryCollectionList.propTypes = {
  subTitle: PropTypes.string,
  categories: PropTypes.array,
  store: PropTypes.object,
};

export default CategoryCollectionList;
